import React, { useEffect, useState } from "react";
import AreaOrdiniMID from "./AreaOrdiniMID";
import { useParams } from 'react-router-dom';
import apiUrl from "../Apiurl";
import { useAuth0 } from '@auth0/auth0-react';

function AreaOrdiniPRE({
  utente,
  ricercaIniz,
  tema,
  vistaINIT,
  urlRicercaINIT,
  perPageINIT,
  inputVuoto,
  colonna,
  titolo,
  keyArea,
  mobile
}) {

  const { user, /* isAuthenticated,  */getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");

  useEffect(() => {
        const getUserMetadata = async () => {
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
        getUserMetadata();
      }, [getAccessTokenSilently, user?.sub]);

  const [ordine, setOrdine] = useState("NO DATA")
  const [vista,setVista] = useState(vistaINIT)
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(perPageINIT);
  const [page, setPage] = useState(1);
  const [columnSort,setColumnSort] = useState("");
  const [directionSort,setDirectionSort] = useState("");
  const [urlRicerca, setUrlRicerca] = useState(urlRicercaINIT);//RIDONDARE QUESTI ULTIMI 4 SOTTO NELL'USEEFFECT
  const [urlParametri, setUrlParametri] = useState(false)
  const [ricerca, setRicerca] = useState({...ricercaIniz,columnSort:columnSort,directionSort: directionSort});
  const [inputIniziale, setInputIniziale] = useState({...ricerca,columnSort:columnSort,directionSort: directionSort}); 
  const {idOrdineDB} = useParams()

  useEffect(() => {
    if (!idOrdineDB || !token) {
      return;
    }
    const controller = new AbortController();
    fetch(apiUrl + "/logistica/ricerca/ricOrdineCodSpedQuerySep/" + idOrdineDB, {
      headers: { Authorization: "Bearer " + token },
      signal: controller.signal,
    })
      .then((resp) => resp.json())
      .then((data) => setOrdine(data || "NO DATA"))
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Errore nel caricamento ordine", error);
        }
      });

    return () => controller.abort();
  }, [idOrdineDB, token]);


  useEffect(() => {
    setUrlRicerca(urlRicercaINIT);
    setUrlParametri(false);
    setRicerca({...ricercaIniz,columnSort:columnSort,directionSort: directionSort});
    setInputIniziale({...ricerca,columnSort:columnSort,directionSort: directionSort})
  }, [keyArea]);

  return (
    <AreaOrdiniMID
      utente={utente}
      ordine={ordine}
      setOrdine={setOrdine}
      urlRicercaINIT={urlRicercaINIT}
      ricercaIniz={ricercaIniz}
      tema={tema}
      urlRicerca={urlRicerca}
      setUrlRicerca={setUrlRicerca}
      perPage={perPage}
      setPerPage={setPerPage}
      page={page}
      setPage={setPage}
      totalRows={totalRows}
      setTotalRows={setTotalRows}
      vista={vista}
      columnSort={columnSort}
      setColumnSort={setColumnSort}
      directionSort={directionSort}
      setDirectionSort={setDirectionSort}
      inputVuoto={inputVuoto}
      colonna={colonna}
      titolo={titolo}
      urlParametri={urlParametri}
      setUrlParametri={setUrlParametri}
      ricerca={ricerca}
      setRicerca={setRicerca}
      inputIniziale={inputIniziale}
      setInputIniziale={setInputIniziale}
      setVista={setVista}
      mobile={mobile}
    />
  )

}

export default AreaOrdiniPRE;
